<template>
  <div id="yearly-fuel-report-list">

    <div class="vx-card p-6 list-container" id="yearly-fuel-report-list-card">
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <div class="table-area">

            <div class="header row aisea-text-14-700-dark-gray">
              <div
                class="cell"
                v-for="(column, index) in columns"
                :key="index"
                :class="'cell-' + column.key"
                :style="'width:' + column.width">
                {{column.label}}
              </div>
            </div>

            <div class="data row aisea-text-14-400-black"
              v-for="( yearlyFuelReport, index ) in yearlyFuelReportList"
              :key="index">

              <div class="cell"
                v-for="(column, index) in columns"
                :key="index"
                :class="'cell-' + column.key"
                :style="'width:' + column.width">

                <div v-if="column.key == 'name'">
                  <div class="aisea-text-14-400-black" :class="{ 'col-data-name-mobile' : ( ['iPhone', 'iPad'].includes(deviceInfo.deviceType) ) }" >{{ yearlyFuelReport.name_ja || yearlyFuelReport.name }}</div>
                </div>
                <div v-if="column.key == 'period'" class="flex justify-start items-center">
                  <v-select
                    :options="yearlyFuelReport.years"
                    v-model="yearlyFuelReport.selectedYear"
                    :reduce="options => options.value"
                    :getOptionKey="(option) => option.value"
                    label="text"
                    :searchable="false"
                    :clearable="false"
                    class="period-select-box aisea-text-14-400-black"
                  ></v-select>
                </div>
                <div v-if="column.key == 'actionButton'"
                  class="w-full flex"
                  :class="[ deviceInfo.deviceType === 'iPhone' ? 'justify-end': 'justify-start' ]"
                >
                  <vs-button
                    @click="executeYearlyFuelReport(yearlyFuelReport)"
                    :color="AISEA_COLOR.BLUE"
                    class="action-button"
                  >統計レポート</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { createNamespacedHelpers } from "vuex";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const EnterpriseVesselApi = AiseaApiFactory.get("enterpriseVessel");
const { mapActions } = createNamespacedHelpers("ecoShip");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import FileSaver from 'file-saver'

export default {
  components: {
    vSelect,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      yearlyFuelReportList: [],
      columns: [],
      baseColumns: [
        {
          key: "name",
          label: "船名",
          width: "288px",
          unit: null
        },
        {
          key: "period",
          label: "レポート期",
          width: "400px",
          unit: null
        },
        {
          key: "actionButton",
          label: "",
          width: "160px",
          unit: null
        },
      ],
      deviceInfo: null,
      currentDate: new Date(),
    }
  },
  computed: {
  },
  watch: {
    onChangeWindowSize() {
      this.onResize();
    },
  },
  methods: {
    ...mapActions(["yearlyFuelReport"]),

    async executeYearlyFuelReport(yearlyFuelReport) {

      let payload = {
        vessel_id: yearlyFuelReport.id,
        yyyy: String(yearlyFuelReport.selectedYear),
      };
      this.$vs.loading();
      try {
        let res = await this.yearlyFuelReport(payload)
        const suffixYear = yearlyFuelReport.selectedYear
        const fileName = `統計レポート_${suffixYear}.xlsx`
        FileSaver.saveAs(res.data, fileName);
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "ダウンロードに失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    },

    // 2020年から今年までを選択肢とする
    yearOptions() {
      const baseYear = 2020
      let options = []
      let year = this.currentDate.getFullYear()
      if( this.currentDate.getMonth() + 1 >= 9 ){
        // 8月期なので、9月以降は来年まで対象
        year++
      }
      for (let i = baseYear; i <= year; i++) {
        options.push(
          {
            text: `${i}年8月期`,
            value: i
          }
        )
      }
      return options
    },

    /**
     *  iPhone,iPadでのレフトメニュー表示制御.
     */
    onResize() {
      if ( this.isIOS() || this.isIPad() ) {
        // iPhone, iPad はメニューを表示しない。
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu');
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
        const verticalNavMenuWidth = this.$store.state.reduceButton
          ? "reduced"
          : "default";
        this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);
      }

      const routerHeaderElements = document.getElementsByClassName("router-header");
      if ( routerHeaderElements ) {
        const cardElement = document.getElementById('yearly-fuel-report-list-card');
         const routerHeaderRect = routerHeaderElements[0].getBoundingClientRect();
        const bottomBuffer =  ( ['iPhone', 'iPad'].includes(this.deviceInfo.deviceType) ? 60 : 80 )+ 'px';
        cardElement.style.setProperty('min-height', `calc( 100vh - ${routerHeaderRect.height}px - ${bottomBuffer} )`) ;
      }
    },

    /**
     *  船舶一覧の生成.
     */
    async setYearlyFuelReportList() {
      // 自社有効船舶をリストで取得
      let payload = {
        is_disabled: false,
        is_deleted: false,
        page: 0,
        limit: 9999,
      };
      let res = await EnterpriseVesselApi.search(payload);
      let vesselList = res.data.vessels;

      let promiseAll = [];
      vesselList
      .filter( vessel => vessel.vessel_origins && vessel.vessel_origins.length > 0 )
      .forEach( vessel => {
        promiseAll.push(new Promise(( resolve ) => {
          const yearlyFuelReport = vessel;
          // 船舶単位の初期処理を記述する

          yearlyFuelReport.years = this.yearOptions();
          yearlyFuelReport.selectedYear = yearlyFuelReport.years[yearlyFuelReport.years.length - 1].value
          resolve(yearlyFuelReport);
        }));
      });
      let resultList = await Promise.all(promiseAll);

      this.yearlyFuelReportList = resultList;
    },

  },
  created() {
    this.deviceInfo = this.getDeviceInfo();

    if ( ['iPhone', 'iPad'].includes(this.deviceInfo.deviceType) ) {
      this.baseColumns.find(x => x.key === 'name').width = "118px";
    }
    if ( this.deviceInfo.deviceType === 'iPhone' ) {
      this.baseColumns.find(x => x.key === 'actionButton').width = "100%";
    }

    const excludeKeys = [];
    if ( this.deviceInfo.deviceType === 'iPhone' ) {
      excludeKeys.push("period");
    }
    this.columns = this.baseColumns.filter(x => !excludeKeys.includes(x.key)  );
  },
  mounted() {

    let routerViewElement = document.getElementsByClassName("router-view")
    routerViewElement[0].style.padding = "2.2rem"

    this.onResize();
    this.setYearlyFuelReportList();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#yearly-fuel-report-list {

  .list-container {
    overflow-x: scroll;
    max-width: 1360px;
    padding: 14px 0px 14px 14px;

  }
  .table-area {
    margin-right: 20px;
  }
  .header {
    font-weight: bold;
  }
  .row {
    min-height: 49px;
    height: fit-content;
    display: flex;
    border-bottom: solid 1px $aisea-light-gray;
    cursor: pointer;
  }
  .cell {
    display: flex;
    margin-right: 20px;
    padding: 5px 10px;
    align-items: center;
    &.cell-vesselName {
      overflow-wrap: anywhere;
    }
  }

  .year-select-box {
    min-width: 7rem;
    width:     7rem;
    margin: 0.4rem 0.2rem 0.4rem 0;
    .vs__dropdown-toggle {
      height: 2.8rem;
    }
    .vs__selected-options {
      padding-top: 0.2rem;
      width: calc(7rem - 26.5px);
    }
  }
  .period-select-box {
    min-width: 22rem;
    width:     22rem;
    margin: 0.4rem 0;
    .vs__dropdown-toggle {
      height: 2.8rem;
    }
  }
  .action-button {
    padding:0.5rem 1.4rem;
  }

  .cell-name {
    margin-right: 0;
  }
  .cell-actionButton {
    margin-right: 0;
  }

  .col-data-name-mobile {
    width: 114px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
